//App.js
import "./App.css";

import ProtectedRoute from "./Component/Auth/ProtectedRoute.jsx";
import AutoLogin from "./Component/Auth/AutoLogin.jsx";
import { lazy, Suspense, useEffect  } from "react";

import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import { setupSweetAlertForNativeAlert } from "./Helper/Dairy Helper/SweetAlertSetup";
import AppRouteSkeleton from "./Component/CleanSlateApp/AppRouteSkeleton/AppRouteSkeleton.jsx";

const Home = lazy(() => import("./Component/home/home"));

const About = lazy(() => import("./Component/home/About.jsx"));

const Contact = lazy(() => import("./Component/home/ContactUs.jsx"));

const Auth = lazy(() => import("./Component/Auth/Auth.jsx"));

const Dashboard = lazy(
	() => import("./Component/CleanSlateApp/Users/Home/Dashboard.jsx"),
);

const UserProfile = lazy(
	() => import("./Component/CleanSlateApp/Users/Home/UserProfile.jsx"),
);

const DiaryWriter = lazy(() => import("./Diary.jsx"));

const BlogForm = lazy(
	() => import("./Component/CleanSlateApp/Users/Home/BlogForm.jsx"),
);

const UpdateBlog = lazy(
	() => import("./Component/CleanSlateApp/Users/Home/UpdateBlog.jsx"),
);

const SlamBook = lazy(
	() => import("./Component/CleanSlateApp/Users/Home//SlamBook/SlamBook.jsx"),
);

const LazyPage = ({ children, compact = false }) => (
	<Suspense fallback={<AppRouteSkeleton compact={compact} />}>
		{children}
	</Suspense>
);

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			{/* Public Routes */}
			<Route
				path="/"
				element={
					<AutoLogin>
						<LazyPage compact>
							<Home />
						</LazyPage>
					</AutoLogin>
				}
			/>
			<Route
				path="/About"
				element={
					<AutoLogin>
						<LazyPage compact>
							<About />
						</LazyPage>
					</AutoLogin>
				}
			/>
			<Route
				path="/Contact"
				element={
					<AutoLogin>
						<LazyPage compact>
							<Contact />
						</LazyPage>
					</AutoLogin>
				}
			/>
			<Route
				path="/Auth"
				element={
					<AutoLogin>
						<LazyPage compact>
							<Auth />
						</LazyPage>
					</AutoLogin>
				}
			/>

			{/* Protected CleanSlate Routes */}
			<Route
				path="/CleanSlate"
				element={
					<ProtectedRoute>
						<LazyPage>
							<Dashboard />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/Profile"
				element={
					<ProtectedRoute>
						<LazyPage>
							<UserProfile />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/PersonalDiary"
				element={
					<ProtectedRoute>
						<LazyPage>
							<DiaryWriter />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/Profile/PersonalDiary"
				element={
					<ProtectedRoute>
						<LazyPage>
							<DiaryWriter />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/Profile/PostBlog"
				element={
					<ProtectedRoute>
						<LazyPage>
							<BlogForm />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/PostBlog"
				element={
					<ProtectedRoute>
						<LazyPage>
							<BlogForm />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/Update/:id"
				element={
					<ProtectedRoute>
						<LazyPage>
							<UpdateBlog />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CleanSlate/Profile/SlamBook"
				element={
					<ProtectedRoute>
						<LazyPage>
							<SlamBook />
						</LazyPage>
					</ProtectedRoute>
				}
			/>
		</>,
	),
);

function App() {

	useEffect(() => {
		setupSweetAlertForNativeAlert();
	}, []);

	return (
		<div className="App">
			<RouterProvider router={router} />
		</div>
	);
}

export default App;
